import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import Modal from 'react-modal';
import axios from "axios";
import styles from "../styles/special.module.css";
import { ImSpinner2 } from "react-icons/im";
import { MdClose } from 'react-icons/md';
import { FaRegTrashAlt, FaRegCheckCircle, FaRuler, FaRegLightbulb, FaRegUser } from "react-icons/fa";
import { FiCheck, FiImage, FiPhone, FiCrop } from "react-icons/fi";
import { LuSofa, LuScan } from "react-icons/lu";
import ProductImage from "./ProductImage";

const SpecialOrderModal = ({ isOpen, onClose }) => {
  const user = useSelector((state) => state.auth.user);

  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [wallWidth, setWallWidth] = useState("");
  // Nothing pre-selected in step 2 — the customer picks "idea" or "suggest"
  const [requestType, setRequestType] = useState("");
  const [note, setNote] = useState("");

  const decorInputRef = useRef(null);
  const exampleInputRef = useRef(null);
  const [decorFile, setDecorFile] = useState(null);
  const [decorPreview, setDecorPreview] = useState(null);
  const [exampleFile, setExampleFile] = useState(null);
  const [examplePreview, setExamplePreview] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setName((prev) => prev || user?.name || "");
      setMobile((prev) => prev || user?.mobile || "");
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDecorImgChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 3 * 1024 * 1024) {
      toast.error(<span className="toast">حجم الملف يجب أن يكون أقل من 3 ميجابايت</span>);
      e.target.value = '';
      return;
    }

    setDecorFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setDecorPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const removeDecorImg = () => {
    setDecorFile(null);
    setDecorPreview(null);
  };

  const handleExampleImgChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 3 * 1024 * 1024) {
      toast.error(<span className="toast">حجم الملف يجب أن يكون أقل من 3 ميجابايت</span>);
      e.target.value = '';
      return;
    }

    setExampleFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setExamplePreview(reader.result);
    reader.readAsDataURL(file);
  };

  const removeExampleImg = () => {
    setExampleFile(null);
    setExamplePreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (step === 1) {
      if (!decorFile) {
        toast.error(<span className="toast">إضافة صورة الحائط مطلوبة</span>);
        return;
      }
      setStep(2);
      return;
    }

    if (!requestType) {
      toast.error(<span className="toast">اختر الطريقة المناسبة اولاً</span>);
      return;
    }

    if (!user) {
      toast.error(<span className="toast">قم بتسجيل الدخول اولا</span>);
      return;
    }

    const shipping_details = { name: name.trim(), mobile: mobile.trim() };
    const order = { wallWidth, requestType, note: requestType === "idea" ? note : "" };

    const formData = new FormData();
    formData.append("shipping_details", JSON.stringify(shipping_details));
    formData.append("order", JSON.stringify(order));
    formData.append("decorImg", decorFile);
    if (requestType === "idea" && exampleFile) {
      formData.append("exampleImg", exampleFile);
    }

    confirmAlert({
      message: `تأكيد إرسال الطلب ؟`,
      buttons: [{
        label: 'نعم',
        onClick: async () => {
          setSubmitting(true);
          try {
            await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}/api/orders/addSpecial`, formData, {
                withCredentials: true
              }
            );
            setSuccess(true);
          } catch (error) {
            toast.error(<span className="toast">لم نتمكن من إرسال الطلب. حاول مرة اخرى</span>);
          } finally {
            setSubmitting(false);
          }
        }
      },
      { label: 'لا' }]
    });
  };

  const resetForm = () => {
    setStep(1);
    setName("");
    setMobile("");
    setWallWidth("");
    setRequestType("");
    setNote("");
    setDecorFile(null);
    setDecorPreview(null);
    setExampleFile(null);
    setExamplePreview(null);
    setSuccess(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {onClose(); resetForm()}}
      className={`custom-modal ${styles.special}`}
      overlayClassName="custom-modal-overlay center"
      ariaHideApp={true}
    >
      <div className={styles.mandala} />

      <button
        type="button"
        aria-label="إغلاق"
        className={styles.closeBtn}
        onClick={() => {onClose(); resetForm()}}
      >
        <MdClose />
      </button>

      {success ?
        <div className="success center" style={{boxShadow: "none"}}>
          <FaRegCheckCircle className="successIcon" />
          <span>تم إرسال الطلب بنجاح</span>
          <p>سنقوم بالتواصل معك فى اقرب وقت. تستطيع التحقق من حالة طلبك فى صفحة طلباتك.</p>
        </div>
      :
        <form onSubmit={handleSubmit}>
          <div className={styles.header}>
            <h2 className={styles.title}>صمم لوحتك مع ديكورك</h2>
            <p className={styles.subtitle}>
              {step === 1
                ? "أرسل لنا تفاصيل المساحة، وسنساعدك بتصميم لوحة تناسب ذوقك وديكور بيتك"
                : "اختر الطريقة المناسبة لتطوير فكرة لوحتك بما يناسب ذوقك ومساحتك"}
            </p>
          </div>

          {!user && <p className="warm">يجب تسجيل الدخول حتى تتمكن من طلب هذه الخدمة</p>}

          <div className={styles.stepper}>
            <div className={styles.stepItem}>
              <div className={`${styles.stepCircle} ${step === 1 ? styles.stepCircleActive : styles.stepCircleDone}`}>1</div>
              <span className={`${styles.stepLabel} ${step === 1 ? styles.stepLabelActive : styles.stepLabelDone}`}>بيانات المساحة</span>
            </div>
            <div className={styles.stepConnector}>
              <div className={`${styles.stepFill} ${step >= 2 ? styles.stepFillActive : ""}`} />
            </div>
            <div className={styles.stepItem}>
              <div className={`${styles.stepCircle} ${step >= 2 ? styles.stepCircleActive : ""}`}>2</div>
              <span className={`${styles.stepLabel} ${step >= 2 ? styles.stepLabelActive : ""}`}>فكرة اللوحة</span>
            </div>
          </div>

          {step === 1 ?
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.cardIcon}><FaRegUser /></div>
                <span className={styles.cardTitle}>1 - المعلومات الأساسية</span>
              </div>

              <div className={styles.grid}>
                <div className={styles.field}>
                  <label>اسم العميل <span className={styles.required}>*</span></label>
                  <div className={styles.inputWrap}>
                    <FaRegUser className={styles.inputIcon} />
                    <span className={styles.inputDivider} />
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      maxLength={30}
                      placeholder="اكتب اسمك"
                      required
                    />
                  </div>
                </div>

                <div className={styles.field}>
                  <label>رقم الهاتف <span className={styles.required}>*</span></label>
                  <div className={styles.inputWrap}>
                    <FiPhone className={styles.inputIcon} />
                    <span className={styles.inputDivider} />
                    <input
                      type="tel"
                      dir="ltr"
                      className={styles.ltrInput}
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      maxLength={20}
                      placeholder="05XXXXXXXX"
                      required
                    />
                  </div>
                </div>

                <div className={styles.field}>
                  <label>عرض الحائط بالمتر <span className={styles.required}>*</span></label>
                  <div className={styles.inputWrap}>
                    <FaRuler className={styles.inputIcon} />
                    <span className={styles.inputDivider} />
                    <input
                      type="number"
                      step={0.01}
                      min={1}
                      max={65535}
                      value={wallWidth}
                      onChange={(e) => setWallWidth(e.target.value)}
                      placeholder="مثال: 3.5"
                      required
                    />
                  </div>
                  <p className={styles.hint}>اكتب عرض الحائط من الطرف إلى الطرف</p>
                </div>

                <div className={styles.field}>
                  <label>صورة الديكور <span className={styles.required}>*</span></label>
                  {decorPreview ?
                    <div className={styles.previewBox}>
                      <ProductImage url={decorPreview} alt="Preview" loading="lazy" />
                      <button
                        type="button"
                        className={styles.removeBtn}
                        onClick={() => { if (submitting) return; removeDecorImg(); }}
                      >
                        <FaRegTrashAlt />
                      </button>
                    </div>
                  :
                    <button
                      type="button"
                      onClick={() => decorInputRef.current.click()}
                      disabled={submitting}
                      className={styles.uploadBox}
                    >
                      <FiImage />
                      <span>إضافة صورة</span>
                    </button>
                  }
                  <input
                    type="file"
                    accept="image/*"
                    ref={decorInputRef}
                    onChange={handleDecorImgChange}
                    style={{display: "none"}}
                  />
                </div>
              </div>

              <div className={styles.tips}>
                <span className={styles.tipsLabel}>لأفضل نتيجة:</span>
                <div className={styles.tipsGrid}>
                  <div className={styles.tip}>
                    <LuSofa />
                    <span>أظهر جزءاً من الأثاث</span>
                  </div>
                  <div className={styles.tip}>
                    <FiCrop />
                    <span>اجعل الصورة مستقيمة</span>
                  </div>
                  <div className={styles.tip}>
                    <LuScan />
                    <span>صوّر الحائط كاملاً</span>
                  </div>
                </div>
              </div>
            </div>
          :
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.cardIcon}><FaRegLightbulb /></div>
                <span className={styles.cardTitle}>2 - اختر الطريقة المناسبة</span>
              </div>

              <div className={styles.options}>
                <div
                  className={`${styles.option} ${requestType === "idea" ? styles.optionActive : ""}`}
                  onClick={() => setRequestType("idea")}
                >
                  <div className={styles.radioOuter}>
                    {requestType === "idea" && <span className={styles.radioInner} />}
                  </div>
                  <div className={styles.optionBody}>
                    <div className={styles.optionTitle}>لدي فكرة وأرغب بتطويرها</div>
                    <div className={styles.optionDesc}>أرسل صورة مرجعية واكتب ملاحظاتك لنطور الفكرة معك</div>

                    {requestType === "idea" &&
                      <div className={styles.optionDetails} onClick={(e) => e.stopPropagation()}>
                        <div>
                          <label>ملاحظاتك (اختيارى)</label>
                          <textarea
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            maxLength={255}
                            placeholder="اكتب اى تفاصيل او الوان او اسلوب تفضله"
                          />
                        </div>

                        <div>
                          <label>صورة للفكرة التى أعجبتك (اختيارى)</label>
                          {examplePreview ?
                            <div className={styles.previewBox}>
                              <ProductImage url={examplePreview} alt="Preview" loading="lazy" />
                              <button
                                type="button"
                                className={styles.removeBtn}
                                onClick={() => { if (submitting) return; removeExampleImg(); }}
                              >
                                <FaRegTrashAlt />
                              </button>
                            </div>
                          :
                            <button
                              type="button"
                              onClick={() => exampleInputRef.current.click()}
                              disabled={submitting}
                              className={styles.uploadBox}
                            >
                              <FiImage />
                              <span>إضافة صورة</span>
                            </button>
                          }
                          <input
                            type="file"
                            accept="image/*"
                            ref={exampleInputRef}
                            onChange={handleExampleImgChange}
                            style={{display: "none"}}
                          />
                        </div>
                      </div>
                    }
                  </div>
                </div>

                <div
                  className={`${styles.option} ${requestType === "suggest" ? styles.optionActive : ""}`}
                  onClick={() => setRequestType("suggest")}
                >
                  <div className={styles.radioOuter}>
                    {requestType === "suggest" && <span className={styles.radioInner} />}
                  </div>
                  <div className={styles.optionBody}>
                    <div className={styles.optionTitle}>أرغب أن تقترحوا علي أفكاراً</div>
                    <div className={styles.optionDesc}>سنراجع صورة الحائط ونعود إليك فى اقرب فرصة باقتراحات مناسبة</div>
                  </div>
                </div>
              </div>
            </div>
          }

          <div className={styles.footer}>
            {step === 2 &&
              <button
                type="button"
                onClick={() => setStep(1)}
                disabled={submitting}
                className={styles.backBtn}
              >
                السابق
              </button>
            }
            <button type="submit" disabled={submitting} className={styles.primaryBtn}>
              {step === 1 ?
                "التالى"
              : submitting ?
                <ImSpinner2 className="smallspinner" />
              :
                <><FiCheck /> إرسال طلب التصميم</>
              }
            </button>
          </div>
        </form>
      }
    </Modal>
  );
};

export default SpecialOrderModal;
